import { PatientType } from "api/patientApi";
import { atom } from "recoil";

export const patientAtom = atom<PatientType | undefined>({
  key: "patient",
  default: undefined,
  effects: [
    () => {
      // 코치 내담자 선택은 영속화하지 않는다 — 새로고침/새 진입 시 무선택으로 시작.
      // (환자 본인 식별은 매 로드 userApi 가 다시 세팅한다)
      // 과거 localStorage 저장 잔여값 정리.
      localStorage.removeItem("patient");
    },
  ],
});
